module.exports = __webpack_public_path__ + "img/fr.4d4a696d.jpg";